<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Training Information</v-stepper-step>

     <!--  <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">Implementing Agency</v-stepper-step> -->

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">Participant Information</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 3" step="3">Entry of Training Expenses</v-stepper-step>

      <v-divider></v-divider>
      <!-- <v-stepper-step step="4">Cost Entry</v-stepper-step> -->
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <TrainingInfoForm v-on:emitForm1="goNextStep" @setTrainingId="setTrainingIdToSiblings"></TrainingInfoForm>
      </v-stepper-content>

      <template>
      <v-stepper-content step="2">
        <ParticipantInfoForm v-on:emitForm3="goNextStep" :get_training_id="get_training_id"></ParticipantInfoForm>
      </v-stepper-content>
      </template>

      <template>
      <v-stepper-content step="3">
        <CostInformation v-on:emitForm4="goNextStep" :get_training_id="get_training_id"></CostInformation>
      </v-stepper-content>
      </template>

      <!-- <template>
      <v-stepper-content step="4">
        <CostEntry v-on:emitForm5="goNextStep"></CostEntry>
      </v-stepper-content>
      </template> -->

    </v-stepper-items>
  </v-stepper>
</template>

<script>
let commonService = require("../../../services/common.service");
import TrainingInfoForm from './step_forms/trainingInfoForm';
import ParticipantInfoForm from './step_forms/participantInfoForm';
import CostInformation from './step_forms/costInformation';
import CostEntry from './step_forms/costEntry';
export default {
  components: {
    TrainingInfoForm,
    //ImplementingAgency,
    ParticipantInfoForm,
    CostInformation,
    CostEntry,
  },
  data() {
    return {
      e1: 0,

      formSchema: {
        pro_code: "",
        pro_start_date: "",
        pro_name: "",
        pro_name: "",
        pro_end_date: "",
        pro_objectives: "",
        pro_location: "",
        total_pro_v: "",
        adp_code: "",
        total_pro_v2: "",
        non_adp_code: "",
        pro_agreement_date: "",
        agreement_ministry: ""
      },
      get_training_id:''
    };
  },
  created() {
   
  },
  methods:{
    // submitOperationActivities()
    // {      
    //   commonService.insertFormData(formSchema, "partner-info").then(res => {           
    //         if(res.status==1) {
    //           this.e1 = 2
    //         }
    //       });
    // },

    goNextStep(num)
    {
      this.e1 = num
    },
    setTrainingIdToSiblings(id){
        this.get_training_id = id
    }
  },

};
</script>


// WEBPACK FOOTER //
// src/components/training/training_information/training_info_form.vue